import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-api-error-modal",
    templateUrl: "./api-error-modal.component.html",
    styleUrls: ["./api-error-modal.component.scss"],
    standalone: false,
})
export class ApiErrorModalComponent {
    constructor(public activeModal: NgbActiveModal) {}
}
